// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setMinutes as fn } from "../setMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setMinutes = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setMinutes;
